export enum MicrositeSocialLinksPosition {
  TOP = 'TOP',
  BOTTOM = 'BOTTOM',
}
